import { SnackbarsActions, SnackbarsContent } from "@/Layouts/components/Snackbars";
import { getPayrollSubmitList } from "@/Washouts/api/PayrollClosing/queries";
import { useQuery } from "@tanstack/react-query";
import { enqueueSnackbar, SnackbarKey } from "notistack";

interface IUseSubmissionHistoryData {
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
}

export const useSubmissionHistoryData = ({ locationId, payPeriodId }: IUseSubmissionHistoryData) => {
	const { data, isLoading } = useQuery({
		queryKey: ["payrollClosing", "submissionHistory", locationId, payPeriodId],
		queryFn: async () => {
			try {
				const results = await getPayrollSubmitList(locationId, payPeriodId);
				return results?.map((entry) => {
					return {
						_id: entry._id,
						submitter: entry.submitter,
						statusDate: entry.statusDate,
						status: entry.status,
						errors: entry.errors,
						position: entry.position,
						companyId: entry.companyId,
						providerPayPeriodId: entry.providerPayPeriodId,
						dateRange: entry.dateRange,
						payPeriodId,
					};
				});
			} catch {
				const renderSnackbarsActions = (key: SnackbarKey) => {
					return <SnackbarsActions key={key.toString()} index={key} />;
				};
				enqueueSnackbar(
					<SnackbarsContent message={"An error occurred retrieving the payroll submission list."} critical={true} />,
					{
						variant: "error",
						preventDuplicate: true,
						action: renderSnackbarsActions,
					}
				);
			}

			return null;
		},

		enabled: !!locationId && !!payPeriodId,
		staleTime: Infinity,
	});

	return { data, isLoading };
};
